import React from "react";
import styled from "styled-components";
import { Employee } from "./Employee";
import { Ingress } from "BaseComponents/Text";
import {
  BlockContainer,
  InnerBlockContainer,
  ContentContainer,
} from "BaseComponents/Wrappers";
import { GetTextColor } from "Helpers/ColorHelper";

export const EmployeeListBlock = ({
  Heading,
  Preamble,
  Contacts,
  BackgroundColor,
}) => {
  const { textColor } = GetTextColor(BackgroundColor);
  return (
    <BlockContainer bgColor={`#${BackgroundColor}`}>
      <InnerBlockContainer>
        <TopWrapper>
          <H2 color={textColor}>{Heading}</H2>
          {Preamble && (
            <Ingress maxWidth="615px" normal color={textColor}>
              {Preamble}
            </Ingress>
          )}
        </TopWrapper>
        <ContentContainer flexWrap="wrap" margin="0 0 0 -15px">
          {Contacts.map((contact, key) => {
            return <Employee key={`contact-${key}`} {...contact} />;
          })}
        </ContentContainer>
      </InnerBlockContainer>
    </BlockContainer>
  );
};

export const TopWrapper = styled.div`
  margin-bottom: 25px;
`;

const H2 = styled.h2`
  margin-bottom: 10px;
  font-family: ${({ theme }) => theme.font};
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${({ color }) => (color ? color : "black")};
`;
